<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5> {{ $t('FILTERS_TITLE') }} </h5>
    </b-card-header>
    <b-card-body>

      <b-row>
        <b-col md="12" sm="12" lg="6" class="mb-md-0 mb-2">
          <label>{{ $t('FILTERS_CATEGORIES_TITLE') }}</label>
            <v-select 
              multiple 
              :close-on-select="false" 
              label="name" 
              :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
              @input="(value) => {
                $store.commit('maintenances.list/updateCategoriesFilter', { value })
                $store.dispatch('maintenances.list/fetchList')
              }" 
              :value="$store.getters['maintenances.list/categoriesFilter']" 
              :options="$store.getters['maintenances.list/categoriesOptions']" 
              class="w-100"
              :reduce="category => category.id"
              :getOptionLabel="category => category.name" 
            />
        </b-col>

        <b-col lg="6" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('FILTERS_OWNERS_TITLE') }}</label>
          <v-select
            multiple 
            :close-on-select="false" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
            @input="(value) => {
              $store.commit('maintenances.list/updateOwnersFilter', { value })
              $store.dispatch('maintenances.list/fetchList')
            }" 
            :value="$store.getters['maintenances.list/ownersFilter']" 
            :options="$store.getters['maintenances.list/ownersOptions']" 
            label="name"
            class="w-100" 
            :reduce="owner => owner.id"
            :getOptionLabel="owner => owner.name" 
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('FILTERS_TYPES_TITLE') }}</label>
          <v-select 
            multiple 
            :close-on-select="false"  
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
            @input="(value) => {
              $store.commit('maintenances.list/updateTypesFilter', { value })
              $store.dispatch('maintenances.list/fetchList')
            }" 
            :value="$store.getters['maintenances.list/typesFilter']"
            :options="$store.getters['maintenances.list/typesOptions']"
            class="w-100" 
            :reduce="type => type.id"
            :getOptionLabel="type => type.name" 
          />
        </b-col>

        <b-col lg="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('FILTERS_CONTRACTS_TITLE') }}</label>
          <v-select 
            multiple 
            :close-on-select="false" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
            @input="(value) => {
              $store.commit('maintenances.list/updateContractsFilter', { value })
              $store.dispatch('maintenances.list/fetchList')
            }" 
            :value="$store.getters['maintenances.list/contractsFilter']"
            :options="$store.getters['maintenances.list/contractsOptions']"
            class="w-100" 
            :reduce="contract => contract.id"
            :getOptionLabel="contract => contract.name" 
          />
        </b-col>

        <b-col lg="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('FILTERS_SUPPORT_DEVICES_TITLE') }}</label>
          <v-select  
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
            @input="(value) => {
              $store.commit('maintenances.list/updateIsSupportFilter', { value })
              $store.dispatch('maintenances.list/fetchList')
            }" 
            :value="$store.getters['maintenances.list/isSupportFilter']"
            :options="$store.getters['maintenances.list/isSupportFilterOptions']"
             class="w-100" 
             :reduce="option => option.id"
             :getOptionLabel="option => option.name" 
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>

import {
  BCard, 
  BCardHeader, 
  BCardBody, 
  BRow, 
  BCol, 
  BButton
} from 'bootstrap-vue'

import vSelect from 'vue-select'

export default {
  components: {
    BRow, 
    BButton,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
